import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'localDateFormat'
})
export class LocalDateFormatPipe implements PipeTransform {
    transform(value: string, ...args: any[]): string {
        if (!value) return '';
        return moment.utc(value).local().format(args[0]);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/local-date-format.pipe.ts